export default "__VITE_ASSET__40283bda__"